import React from 'react';
import { motion } from 'motion/react';
import { Sprout, Droplets, Package, Recycle } from 'lucide-react';

const STEPS = [
  { icon: Sprout, title: '1. Ethical Sourcing', desc: 'We partner with local Nyeri farmers to handpick the finest Hass avocados.' },
  { icon: Droplets, title: '2. Cold-Pressing', desc: 'Avocados are cold-pressed without heat or chemicals to retain raw nutrients.' },
  { icon: Package, title: '3. Pure Bottling', desc: 'The emerald green oil is filtered and bottled in dark glass to preserve quality.' },
  { icon: Recycle, title: '4. Zero-Waste', desc: 'Leftover skins and seeds are repurposed into organic compost and biomass energy.' },
];

export const ProcessSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-heading font-bold text-gray-900 mb-4">Farm to Bottle</h2>
          <div className="h-1 w-20 bg-avo-gold mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our transparent, sustainable process that guarantees premium quality while protecting the environment.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-stone-200 z-0"></div>
          
          {STEPS.map((step, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2 }}
              className="relative z-10 flex flex-col items-center text-center"
            >
              <div className="w-24 h-24 bg-white border-4 border-stone-100 rounded-full flex items-center justify-center mb-6 shadow-lg text-avo-forest group hover:border-avo-gold transition-colors">
                <step.icon size={40} className="group-hover:scale-110 transition-transform" />
              </div>
              <h3 className="text-xl font-bold font-heading text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
